<div id="spinnercomponent">
    <div class="iconspinner"></div>
    <div class="textspinner"><ng-content></ng-content></div>
</div>
